import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import HowItWorks from "@/components/sections/HowItWorks";
import Features from "@/components/sections/Features";
import ContactForm from "@/components/sections/ContactForm";
import Footer from "@/components/sections/Footer";

export default function LaunchPage() {
    return (
        <main
            data-testid="launch-page"
            className="relative min-h-screen text-white font-body antialiased"
        >
            <Navbar />
            <Hero />
            <HowItWorks />
            <Features />
            <ContactForm />
            <Footer />
        </main>
    );
}
